import { usePaymentEditDialog } from '@/domains/billing/composables/usePaymentEditDialog';
import { getSubBus } from '@/platform/host-sdk/host-bridge';
import { reportManualError } from '@/platform/telemetry/frontend-alert';
import { SUB_EVENTS, onMessage } from '@celerdata/host-bridge-contract';

// Transient sub→host wiring: the wujie sub fires `sub:payment-edit`
// with a Stripe setup-intent secret; this listener opens the host-side
// dialog so Stripe Elements can mount in the host JS realm (avoiding
// the cross-realm postMessage misroute wujie's sandbox introduces).
//
// Delete this file when /billing ports natively — the same composable
// is the calling API in that future code path, so removing the listener
// has no other ripple.

let installed = false;

export function installPaymentEditBridge(): void {
  if (installed) return;
  installed = true;
  onMessage(getSubBus(), SUB_EVENTS.PAYMENT_EDIT, (payload) => {
    // Guard against a malformed payload — the client-secret endpoint
    // CAN return a non-error response with no secret string, and
    // opening the dialog anyway leaves the user with a permanently
    // blank form because Stripe.elements({ clientSecret: undefined })
    // never fires the ready event. Fail loud in telemetry instead.
    if (!payload?.clientSecret) {
      reportManualError(
        'payment_edit_missing_client_secret',
        'sub:payment-edit fired without clientSecret',
        {
          accountID: payload?.accountID,
          mode: payload?.mode,
        },
      );
      return;
    }
    usePaymentEditDialog().open(payload);
  });
}
